import { motion } from "framer-motion";
import { Paintbrush, Home, Layers, Sparkles, Square, Hammer } from "lucide-react";

const services = [
  { icon: Paintbrush, title: "Innenanstrich", text: "Wände, Decken und Räume in der Farbe Ihrer Wahl – sauber und ohne Spuren." },
  { icon: Home, title: "Fassadenarbeiten", text: "Schutz und Optik für Ihre Außenfassade – witterungsbeständig und langlebig." },
  { icon: Layers, title: "Tapezieren", text: "Vom klassischen Raufaser bis zur Designtapete – mit Auge fürs Detail." },
  { icon: Sparkles, title: "Lasuren & Effekte", text: "Spachteltechniken, Wischtechniken und Lasuren für besondere Räume." },
  { icon: Square, title: "Bodenbeläge", text: "Verlegen von Vinyl, Laminat und Designböden mit Präzision." },
  { icon: Hammer, title: "Renovierung", text: "Komplette Renovierungen aus einer Hand – schnell und zuverlässig." },
];

export default function Services() {
  return (
    <section id="services" data-testid="services-section" className="py-24 sm:py-32 bg-sand-100">
      <div className="max-w-7xl mx-auto px-6 sm:px-12">
        <div className="max-w-2xl mb-16">
          <p className="text-xs uppercase tracking-[0.25em] text-sage font-bold mb-6" data-testid="services-overline">Was wir können</p>
          <h2 className="font-display text-4xl sm:text-5xl tracking-tight text-stone-900 leading-tight" data-testid="services-headline">
            Leistungen, die <em className="text-clay">Hand und Fuß</em> haben.
          </h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {services.map((s, idx) => (
            <motion.div
              key={s.title}
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-50px" }}
              transition={{ duration: 0.6, delay: idx * 0.08 }}
              data-testid={`service-card-${idx}`}
              className="p-8 bg-white border border-sand-300 rounded-sm hover:border-clay transition-colors duration-300 group"
            >
              <s.icon className="w-7 h-7 text-clay mb-6 group-hover:scale-110 transition-transform duration-300" strokeWidth={1.5} />
              <h3 className="font-display text-2xl text-stone-900 mb-3">{s.title}</h3>
              <p className="text-stone-600 leading-relaxed">{s.text}</p>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
